import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Wrapper } from './components/Wrapper';

export const VerificationSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('', { keyPrefix: 'emailVerification' });
  return (
    <Wrapper>
      <Stack gap={2}>
        <Typography variant="h2">{t('verificationSuccess.title')}</Typography>
        <Typography>{t('verificationSuccess.body')}</Typography>
      </Stack>
      <Button onClick={() => navigate('/')} sx={{ fontSize: '0.875rem', mt: 3 }}>
        {t('verificationSuccess.continue')}
      </Button>
    </Wrapper>
  );
};
